import { StyleSheet, View } from "react-native";
import { InfoIcon } from "lucide-react";
import CustomText from "../../../common/general/CustomText/CustomText";

export function InfoCard({ title, items }: { title: string; items: string[] }) {
  return (
    <View style={styles.infoCard}>
      <View style={{ marginTop: 2 }}>
        <InfoIcon size={20} color="#075985" />
      </View>
      <View style={{ flex: 1 }}>
        <CustomText
          text={title}
          size="m"
          useTranslationText={false}
          textType="text"
          weight="bold"
          role="heading"
          aria-level="1"
          style={{ color: "#101828", marginBottom: 2 }}
        />
        {items.map((item, index) => (
          <CustomText
            key={`${item}-${index}`}
            text={`• ${item}`}
            size="s"
            useTranslationText={false}
            textType="text"
            weight="normal"
            role="heading"
            aria-level="1"
            style={{ color: "#344054", marginTop: 6 }}
          />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  infoCard: {
    backgroundColor: "#E0F2FE",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#38BDF8",
    padding: 24,
    flexDirection: "row",
    gap: 10,
    marginTop: 20,
  },
});
